// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d621cb42","413":"bbb951ea","988":"5b1ebb70"}[chunkId] + ".chunk.js";
};